import { ResponseV2 } from "@/types/responseV2";
import { apiClientV2 } from "./apiClientV2";
import { ClientV2, NewClientV2Payload } from "@/types";

const getClientsV2 = () =>
  apiClientV2.get<ResponseV2<ClientV2[]>, ResponseV2<ClientV2[]>>("/clients");
const getClientV2 = (id: number) =>
  apiClientV2.get<ResponseV2<ClientV2>, ResponseV2<ClientV2>>(`/clients/${id}`);

const postClientV2 = (payload: NewClientV2Payload) =>
  apiClientV2.post<ResponseV2<ClientV2>, ResponseV2<ClientV2>>(
    "/clients",
    payload
  );

const patchClientV2 = (id: number, payload: NewClientV2Payload) =>
  apiClientV2.post<ResponseV2<ClientV2>, ResponseV2<ClientV2>>(
    `/clients/${id}`,
    payload
  );

export const clients = {
  get: getClientV2,
  getAll: getClientsV2,
  post: postClientV2,
  patch: patchClientV2,
};
